import { motion } from "framer-motion"
import {
  RiBox3Line,
  RiChat3Line,
  RiFireLine,
  RiSearchLine,
  RiSparkling2Line,
  RiTruckLine,
} from "@remixicon/react"

import { cn } from "@/lib/utils"

import { easeOut } from "./marketing-motion"

type StorePreviewMockProps = {
  className?: string
  brandName?: string
  handle?: string
}

const linkButtons = [
  { label: "Shop products", icon: RiBox3Line, primary: true },
  { label: "WhatsApp us", icon: RiChat3Line, primary: false },
  { label: "New arrivals", icon: RiSparkling2Line, primary: false },
  { label: "Bestsellers", icon: RiFireLine, primary: false },
] as const

export function StorePreviewMock({
  className,
  brandName = "Frayz Kiddies",
  handle = "frayzkiddies",
}: StorePreviewMockProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24, rotate: 1 }}
      animate={{ opacity: 1, y: 0, rotate: 0 }}
      transition={{ delay: 0.2, duration: 0.6, ease: easeOut }}
      className={cn(
        "relative mx-auto w-full max-w-[280px] rounded-[2rem] border-4 border-foreground/10 bg-card p-4 shadow-[0_32px_80px_-24px_rgba(69,24,146,0.35)] sm:max-w-[300px]",
        className,
      )}
    >
      <div className="mx-auto size-16 rounded-full bg-primary/15 ring-2 ring-primary/20" />
      <p className="mt-3 text-center font-heading text-lg text-foreground">{brandName}</p>
      <p className="text-center text-xs text-muted-foreground">@{handle}</p>
      <p className="mt-2 text-center text-[11px] leading-snug text-muted-foreground">
        Cute kids wear &amp; accessories. DM-free shopping.
      </p>
      <div className="mt-4 space-y-2">
        {linkButtons.map((btn, i) => (
          <motion.div
            key={btn.label}
            initial={{ opacity: 0, x: -8 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.35 + i * 0.05, duration: 0.35, ease: easeOut }}
            className={cn(
              "flex items-center justify-center gap-2 rounded-full py-2.5 text-xs font-semibold",
              btn.primary
                ? "bg-primary text-primary-foreground"
                : "bg-muted text-foreground ring-1 ring-border",
            )}
          >
            <btn.icon className="size-3.5" />
            {btn.label}
          </motion.div>
        ))}
      </div>
      <div className="mt-4 grid grid-cols-2 gap-2">
        {[1, 2].map((n) => (
          <div
            key={n}
            className="aspect-square rounded-2xl bg-muted ring-1 ring-border"
          />
        ))}
      </div>
    </motion.div>
  )
}
